import { ComboboxProps, ComboboxSelect } from '@chronosphereio/chrono-ui';
import { DEFAULT_ALL_VALUE } from '@chronosphereio/core';

/**
 * A shim for combobox where we can define our standard all value and widths, etc
 */

export function VariableCombobox(props: ComboboxProps) {
  return <ComboboxSelect onReset={() => null} {...props} allValue={DEFAULT_ALL_VALUE} />;
}
